import Util from "./Util.js";

class V2TutorialTemplete {
    // 1. describe and create/initiate our object.
    constructor() {
        // tutorial content

        this.sidebar = document.getElementsByClassName('js-ru-side-nav')[0],
        //this.mainHeader = document.getElementsByClassName('js-ru-main-header')[0],
        this.mobileNavTrigger = document.getElementsByClassName('js-ru-nav-trigger')[0];
        this.sidebarCloseBtn = document.getElementsByClassName("sidebar-close-btn")[0];
        
        this.events();
    }

    events() {
        var wrapper = document.querySelector(".sidebar-item-wrapper");
        if(wrapper !== null) {
            var elementArray = wrapper.querySelectorAll(".wrapper-click-element");
            //console.log("elementArray : ", elementArray);
            for (let i = 0; i < elementArray.length; i++) {
                elementArray[i].addEventListener('click', e => this.clickHandler(e));  
                //console.log("checkboxArray  element: ", elementArray[i]);
            }
        }

        //on mobile, open sidebar when clicking on menu icon
        if(this.mobileNavTrigger !== undefined && this.mobileNavTrigger !== null) {
            this.mobileNavTrigger.addEventListener('click', event => this.mobileNavBtnClick(event));
        }
        if(this.sidebarCloseBtn !== undefined && this.sidebarCloseBtn !== null) {
            this.sidebarCloseBtn.addEventListener('click', event => this.mobileNavBtnClick(event));
        }
    }

    hasClass(el, className) {
        if (el.classList) return el.classList.contains(className);
        else return !!el.className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'));
    }

    toggleClass(el, className, bool) {
        if(bool) this.addClass(el, className);
        else this.removeClass(el, className);
    }
    addClass(el, className) {
        var classList = className.split(' ');
         if (el.classList) el.classList.add(classList[0]);
         else if (!this.hasClass(el, classList[0])) el.className += " " + classList[0];
         if (classList.length > 1) this.addClass(el, classList.slice(1).join(' '));
    } 
    removeClass(el, className) {
        var classList = className.split(' ');
        if (el.classList) el.classList.remove(classList[0]);	
        else if(this.hasClass(el, classList[0])) {
            var reg = new RegExp('(\\s|^)' + classList[0] + '(\\s|$)');
            el.className=el.className.replace(reg, ' ');
        }
        if (classList.length > 1) this.removeClass(el, classList.slice(1).join(' '));
    }

    mobileNavBtnClick(event) {
        if(this.sidebar === undefined || this.sidebar === null) {
            return;
        }
        console.log("1 Sidebar open button click >>>>>")
        event.preventDefault();
        var toggle = !this.hasClass(this.sidebar, 'ru-side-nav--is-visible');
        //if(toggle) this.expandSidebarItem();
        this.toggleClass(this.sidebar, 'ru-side-nav--is-visible', toggle);
        this.toggleClass(this.mobileNavTrigger, 'ru-nav-trigger--nav-is-visible', toggle);
        console.log("2 Sidebar open button click >>>>>")
    }

    expandSidebarItem() { // show dropdown of the selected sidebar item
        this.addClass(this.sidebar.getElementsByClassName('ru-side__item--selected')[0], 'ru-side__item--expanded');
    }
   
    clickHandler(event) {
        console.log("clickHandler >>>>>>>>>>>>>>>>>>>>>> event.target.parentElement ", event.target.parentElement);        
        if(event.target.parentElement !== null) {            
            event.target.parentElement.click();

            console.log("event.target.parentElement.htmlFor: ", event.target.parentElement.htmlFor);
            const inputElement = document.getElementById(event.target.parentElement.htmlFor);
            if(inputElement !== null) {
                console.log("inputElement.checked: ", inputElement.checked);

                var spanElement = event.target.getElementsByClassName("sidebar-item-symbol")[0];
                console.log("spanElement: ", spanElement); 
                if(spanElement !== undefined && spanElement !== null) {
                    console.log("spanElement.innerHTML: ", spanElement.innerHTML);
                    // if(spanElement.innerHTML !== "") {
                    //     spanElement.innerHTML = inputElement.checked ? "- " : "+ ";
                    // }

                    if(this.hasClass(spanElement, 'sidebar-item-symbol-collapsed') || this.hasClass(spanElement, 'sidebar-item-symbol-expand')) {
                        if(inputElement.checked) {
                            this.addClass(spanElement, 'sidebar-item-symbol-expand');
                            this.removeClass(spanElement, 'sidebar-item-symbol-collapsed');
                        } else {
                            this.addClass(spanElement, 'sidebar-item-symbol-collapsed');
                            this.removeClass(spanElement, 'sidebar-item-symbol-expand');
                        }
                    }
                }                
            }

        }
    }
}

export default V2TutorialTemplete; 